import { useContext } from "react";
import { PermissionContext } from "../context/Permissions";

const usePermission = () => useContext(PermissionContext);
export default usePermission;
